export function SET_SHOW_GLOBAL_SEARCH({ commit }, [show_global_search]) {
	commit('SAVE_SHOW_GLOBAL_SEARCH', [show_global_search])
}

export function SET_IS_TAG({ commit }, [is_tag]) {
	commit('SAVE_IS_TAG', [is_tag])
}
